import React from 'react';
import { useGlobal } from 'reactn';
import { Focuspoint } from 'components/Focuspoint';
import SearchBar from 'components/SearchBar';

const Home = (props) => {

  const claimImgSrc = window.ict?.wyby?.orgClaimImage;
  const [masterData] = useGlobal('masterData');
  const organization = masterData.organization;

  return (
    <>
      <section className="mainimg-container">
        <div className="wrapper claim-container">
          <div className="row">
            <div className="column-5 claim">
              <h1 className="mali-blue"><span dangerouslySetInnerHTML={{ __html: organization.Title }}></span></h1>
              <h3>{organization.Claim}</h3>
            </div>
          </div>
        </div>
        <div className="row img-container">
          <div className="column-7 offset-5">
            <Focuspoint
              src={claimImgSrc}
              imageW={1600}
              imageH={961}
              focusX={0.0}
              focusY={0.0}
              reCalcOnWindowResize={true}
            />
          </div>
        </div>
      </section>
      <SearchBar page="Home" />
    </>
  );
}

export default Home;